import {
  RegionService,
  MillSectorTypeService,
  MillService,
  LocationService,
} from '@planning/proxy/planning/controllers';
import { MeasurementTypeService } from '@woodsupply/proxy/wood-supply/controllers/measurement-type.service';
import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MenuCategories, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuSubcategories } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const MILLSECTOR_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('name', 'Entity.MillSector.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder.text('remsoftName', 'Entity.MillSector.RemsoftName')
    .maxLength(200)
    .build(),
  FieldBuilder.checkbox('isActive', 'Entity.MillSector.IsActive').build(),
  FieldBuilder.foreignKey('millId', 'Entity.Mill', MillService)
    .required()
    .displayFromNested('mill.name')
    .sortBy('mill.name')
    .build(),
  FieldBuilder.foreignKey(
    'millSectorTypeId',
    'Entity.MillSectorType',
    MillSectorTypeService
  )
    .required()
    .displayFromNested('millSectorType.name')
    .sortBy('millSectorType.name')
    .build(),
  FieldBuilder.foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const MILLSECTOR_CONFIG = {
  entityName: 'MillSector',
  localizationKey: 'Planning::Entity.MillSector',
  fields: MILLSECTOR_FIELDS,
  permission: 'GeneralLocations.MillSectors',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Locations + MENU_NAME_SUFFIX,
};
